// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2daZeji6NTBpLZFKlYNY2z","title":"_1M5s0VZnzXGio_TM-h4NRn","info":"_1t_TzOZ5HvumEEAUyNEYKg","label":"_1rkbHfk97XJtC8w6Au4e9Y","buttonSection":"_2_gDunO7D6ginQlzDmpZti"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Skills/components/DeleteSkill.mod.css
// module id = 1124
// module chunks = 0